export default "__VITE_ASSET__RJ13w66v__"